import React from 'react';
import navarrow from "../assets/back_btn.png";
import { BONUSSUMMERY_STRINGS } from "../Strings";
import { staticWebUrl } from '../ApiConstants.js';

class AcePoints extends React.Component {
  constructor() {
    super();
    this.state = {
      iFrameHeight: '0px',
      channel: window.sessionStorage["channel"]
    }
  }

  handlebackbtn = () => {
    this.props.history.push("/activeoffers/")
  }

  componentDidMount() {

  }
  render() {

    return (
      <div className="" style={{marginTop:'50px', position:'relative', top: '10px', overflow:'hidden'}}>
        <nav
          className=" ph2 pv2 tr fixed top-0 left-0 right-0 shadow-4 z-999 "
          style={{ backgroundColor: "#eabf69", color: "#032146" }}
        >
          <div className="w-100  db center ">
            <div className="flex justify-start items-center" >
              <img fill="#ffffff"
                className="w1"
                src={navarrow}
                alt="no available"
                style={{ width: "25px" }} onClick={() => this.handlebackbtn()} />
              <p className="f4-l f4 mv0 text-medium tc ml2">{BONUSSUMMERY_STRINGS.KEY_BONUS_SUMMARY}</p>
            </div>
          </div>

        </nav>



        {/* <div className="ph2 ph6-l f6 f4-l f5-ns tc center bg-white" style={{ height:"100%",width:"100%",paddingTop: "3rem", overflow:"hidden"}} height="100%" width="100%"> */}
        {(this.state.channel == "PKAPS" || this.state.channel == "PKIPS") ? 
        <div style={{overflow: 'hidden'}}>
          {/* pl-3827 */}
          <iframe style={{ paddingTop: "0rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "" }} height="100vh" width="100%" title="" frameBorder="0px" overflowY="scroll" src={"https://a23poker.com/offers.html?src=mapp&platformapp=Y&header=N"} >
          </iframe>
        </div>
          : (this.state.channel == "HPS" || this.state.channel == "hps" || this.state.channel == "A23HPS") ? 
          <div style={{overflow: 'hidden'}}>
            {/* pl-3827 */}
            <iframe style={{ paddingTop: "0rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "" }} height="100vh" width="100%" title="" frameBorder="0px" overflowY="scroll" src={process.env.REACT_APP_PLAY_STATIC_WEB_URL + "rummybonus.html?src=mapp&platformapp=Y&header=N"} >
            </iframe>
          </div> 
          : 
          <div style={{overflow: 'hidden'}}>
            <iframe style={{ paddingTop: "0rem", marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "" }} height="100vh" width="100%" title="" frameBorder="0px" overflowY="scroll" src={process.env.REACT_APP_REAL_STATIC_WEB_URL + "rummybonus.html?src=mapp&platformapp=Y&header=N"} >
            </iframe>
          </div>}
        {/* </div> */}
      </div>

    );
  }
}
export default AcePoints;